import * as React from "react"
import { Link } from "gatsby"
import { StaticImage } from "gatsby-plugin-image"

import Layout from "../components/layout"
import Seo from "../components/seo"

import { Container, Button } from "shards-react"

import MobileView from "../common/mobileView"
import BrowserView from "../common/browserView"

import ChatIcon from "../icons/chat"

const URL = "https://tawk.to/chat/60561c51067c2605c0ba8e34/1f185t7po"

const ChatPage = props => (
  <Layout countryCode={props.pageContext.countryCode || ""}>
    <Seo title="Chat" countryCode={props.pageContext.countryCode || ""} />

    <BrowserView>
      <iframe src={URL} style={{ height: "600px" }} />
    </BrowserView>

    <MobileView>
      <br />
      <Container>
        <ChatIcon />

        <p className="text-center">
          You're about the begin a chat session. To start the chat, please click
          the 'Start Chat' button below. Please provide the agent with your name
          and email so you can be contacted in case you get disconnected.
        </p>

        <br />
        <Button
          href={URL}
          target="_blank"
          className="center"
          style={{ width: "75%" }}
        >
          <i className="fa-solid fa-comments pr-2"></i>
          Start Chat
        </Button>
      </Container>
    </MobileView>
  </Layout>
)

export default ChatPage
